import axiosInstance from './axios';
import axios, { AxiosResponse } from 'axios';

import {
  API,
  CLIENT,
  BOOSTED_PHRASES,
} from './endpoints';
import { config } from '../config';


const backendUrl: string = config.backendApiUrl;
const baseUrl = `${backendUrl}/${API}/${CLIENT}`;

export interface ILocalBoostedPhrase {
    id: number;
    boost: string;
    phrase: string;
}

export type LocalBoostedPhrasesList = ILocalBoostedPhrase[];

export interface IBoostedPhrase {
    id: number;
    boost: number | string;
    phrase: string;
}

export type BoostedPhrasesList = IBoostedPhrase[]
export const getBoostedPhrases = (): Promise<AxiosResponse<BoostedPhrasesList>> => axiosInstance.get(`${baseUrl}/${BOOSTED_PHRASES}`);

export const postBoostedPhrase = (phrase: IBoostedPhrase) => {
    return axiosInstance.post(
        `${baseUrl}/${BOOSTED_PHRASES}`,
        { 
            phrase: phrase.phrase,
            boost: phrase.boost
        }
    );
}

export const deleteBoostPhrase = (phraseId: number) => axiosInstance.delete(`${baseUrl}/${BOOSTED_PHRASES}/${phraseId}`);

export const patchBoostPhrase = (phrase: Partial<IBoostedPhrase>) => {
    return axiosInstance.patch(
        `${baseUrl}/${BOOSTED_PHRASES}/${phrase.id}`,
        { 
            phrase: phrase.phrase,
            boost: phrase.boost
        }
    );
}